<template>
  <div class="h-screen flex flex-col bg-gray-50 overflow-hidden">
    <div class="h-full flex flex-row">
      <!-- Sidebar placeholder — fixed widths align 1:1 with .sm-expanded/.sm-collapsed so there's no gap between sidebar and main. -->
      <div
        :style="sidebarCollapsed ? 'width: 72px; flex-shrink: 0;' : 'width: 260px; flex-shrink: 0;'"
        class="h-full transition-all duration-300 ease-in-out"
      >
        <the-side-menu @collapse-change="onCollapseChange"></the-side-menu>
      </div>
      <!-- Main content area — no top header; the sidebar carries user/logout/limit. -->
      <div class="h-full flex flex-col flex-1 min-w-0 transition-all duration-300 ease-in-out">
        <!--
          IST clock strip — top-right, opposite where page titles render.
          A flow element (not an overlay) so it can never collide with the
          action buttons pages place in their own header rows (Pay-In's
          Export/Refresh, Ledger's Manual Entry, etc.). Intl with an
          explicit Asia/Kolkata timezone → correct Indian time on any
          device timezone.
        -->
        <div class="ist-strip">
          <div class="ist-pill" title="Current time in India (IST) — all order timestamps use this clock">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ist-icon">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v5l3 3" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span class="ist-time">{{ istTime }}</span>
            <span class="ist-sub">{{ istDate }} · IST</span>
          </div>
        </div>
        <div class="flex-1 overflow-y-hidden flex flex-col">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TheSideMenu from "../components/layout/TheSideMenu.vue";
export default {
  name: "dashboard-layout",
  components: {
    TheSideMenu,
  },
  data() {
    return {
      sidebarCollapsed: localStorage.getItem('sidemenu_collapsed') === 'true',
      istTime: "",
      istDate: "",
      clockTimer: null,
    };
  },
  mounted() {
    this.tickIstClock();
    this.clockTimer = setInterval(this.tickIstClock, 1000);
  },
  beforeUnmount() {
    if (this.clockTimer) clearInterval(this.clockTimer);
  },
  methods: {
    onCollapseChange(collapsed) {
      this.sidebarCollapsed = collapsed;
    },
    tickIstClock() {
      const now = new Date();
      this.istTime = now.toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
      this.istDate = now.toLocaleDateString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
      });
    },
  },
};
</script>

<style scoped>
.ist-strip {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  padding: 6px 20px 0;
  background: transparent;
  /* Deliberately a FLOW row (no negative-margin overlay): several pages
     put action buttons at the top-right of their own headers, and an
     overlay pill would brush against them. The strip costs ~30px of
     height and is guaranteed collision-free on every page. */
}
.ist-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 12px;
  border-radius: 999px;
  background: #ffffff;
  border: 1px solid #ede9df;
  box-shadow: 0 4px 12px -8px rgba(27, 42, 71, 0.25);
  pointer-events: auto;
}
.ist-icon {
  width: 13px;
  height: 13px;
  color: #1B2A47;
  flex-shrink: 0;
}
.ist-time {
  font-size: 12.5px;
  font-weight: 700;
  color: #1B2A47;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.ist-sub {
  font-size: 11.5px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8a8371;
  font-weight: 700;
  white-space: nowrap;
}
</style>
